export default LandscapeElements

/** @ngInject */
function LandscapeElements() {
    const LandscapeElements = []

    return {
        LandscapeElements,
    }
}



// WEBPACK FOOTER //
// ./src/services/landscape/landscapeElements.js